import { EventIconAndTime } from "@components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { EventNameAndPlayerName } from "@components/StatsConsole/Widgets/OverviewWidget/parts/EventNameAndPlayerName";
import { formatEventTime } from "@utils/functions";
import { useRef, useState, useEffect } from "react";

interface ICommonEventProps {
    event_type: string;
    player: string;
    team: string;
    time: string;
    height: string;
    label?: string | null;
    isDescBold?: boolean;
    isPlusSignNeeded?: boolean;
}

export const CommonEventHeightHome = ({ player, team, time, event_type, height, label, isDescBold = false, isPlusSignNeeded = false }: ICommonEventProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    const commonEventHeightHomeRef = useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = useState<number>(0);

    useEffect(() => {
        if (commonEventHeightHomeRef.current) {
            setContainerWidth(commonEventHeightHomeRef.current.offsetWidth);
        }
    }, []);

    return (
        <div 
            data-testid="overview-common-event-height-home"
            ref={commonEventHeightHomeRef} 
            className={`flex justify-start mx-[16px] mb-[8px] min-h-[${height}px] max-h-[${height}px]`}>
            <EventIconAndTime iconName={event_type} time={formattedTime} />
            <EventNameAndPlayerName 
                ml="8px" 
                mr="8px" 
                startPosition='start' 
                event_type={event_type} 
                player={player} 
                label={label}
                isDescBold={isDescBold} 
                containerWidth={containerWidth} 
            />
        </div>
    )
}

export const CommonEventHeightAway = ({ player, team, time, event_type, height, label, isDescBold = false, isPlusSignNeeded = false }: ICommonEventProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    const commonEventHeightAwayRef = useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = useState<number>(0);

    useEffect(() => {
        if (commonEventHeightAwayRef.current) {
            setContainerWidth(commonEventHeightAwayRef.current.offsetWidth);
        }
    }, []);

    return (
        <div 
            data-testid="overview-common-event-height-away"
            ref={commonEventHeightAwayRef} 
            className={`flex justify-end mx-[16px] mb-[8px] min-h-[${height}px] max-h-[${height}px]`}>  {/* end do zmiennej? */}
            <EventNameAndPlayerName 
                ml="8px" 
                mr="8px" 
                startPosition='end' 
                event_type={event_type} 
                player={player} 
                label={label}
                isDescBold={isDescBold}
                containerWidth={containerWidth} 
            />
            <EventIconAndTime iconName={event_type} time={formattedTime} />
        </div>
    )
}